import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { setLoader, setParams, setContainerClassnames } from "../../../redux/actions";
import {
  Row,
  Card,
  CardBody,
  Button,
  ModalHeader,
  ModalBody,
  ModalFooter
} from "reactstrap";
import CustomModal from "../../../components/utils/CustomModal";
import { Colxx } from "../../../components/common/CustomBootstrap";
import _axios from "../../../libs/axios";
import { NotificationManager } from "../../../components/common/react-notifications";
import AppLocale from "../../../config/lang";
import FormCustom from "../../../components/utils/FormCustom";
import { cloneDeep } from "lodash"
import Icons from '../../../data/icons';
import CustomDropdown from "../../../components/utils/CustomDropdown";
import themeColors from "../../../data/themeColors";
import Dialog from "../../../components/utils/Dialog";

class Start extends Component {
  constructor(props) {
    super(props)

    this.state = {
      data: [],
      form: null,
      fields: [],
      defaultFields: [],
      idItemSelected: null,
      isAdmin: null,
      userMenu: [],
      message: null,
      companyProfileForm: null,
      companyProfileFields: [],
      ready: false,
      // upload files
      uploadActive: -1,
      uploadFiles: null,
      dialog: {
        isOpen: false,
        toggle: () => {},
        title: null,
        msg: null,
        confirm: () => {}
      }
    }

    this.M = "admModule."
    this.L = AppLocale[props.locale].messages
  }

  UNSAFE_componentWillMount () {
    this.fetchModules()
    this.createFormOne()
  }

  componentDidMount () {
    if (window.innerWidth >= this.props.menuHiddenBreakpoint) this.props.setContainerClassnames(2,"menu-default",true)
  }

  componentDidUpdate (prevProps, prevState) {
  }

  componentWillUnmount () {
    if (window.innerWidth >= this.props.menuHiddenBreakpoint) this.props.setContainerClassnames(1,"menu-default",true)
  }

  createFormOne () {
    const fields = [
      {
        col: 4,
        name: "name",
        value: "",
        type: "text",
        label: "main.name",
        rules: "required",
        opts: {
          style: "float-label"
        }
      },
      {
        col: 8,
        name: "desc",
        value: "",
        type: "text",
        label: "main.desc",
        rules: "required",
        opts: {
          style: "float-label"
        }
      },
      {
        col: 4,
        name: "icon",
        value: "",
        type: "select",
        label: "main.icon",
        opts: {
          style: "float-label",
          items: Icons,
          withIcon: true
        }
      },
      {
        col: 4,
        name: "parentId",
        value: "",
        type: "select",
        label: `${this.M}groupMenu`,
        opts: {
          style: "float-label",
          path: "admModule/get?level=0&pick=true"
        }
      },
      {
        col: 4,
        name: "sort",
        value: "",
        type: "number",
        label: "main.order",
        rules: "required",
        opts: {
          style: "float-label"
        }
      },
      {
        col: 6,
        name: "userRead",
        value: "",
        type: "select",
        label: `${this.M}userGroupAccess`,
        opts: {
          style: "float-label",
          path: "admGroup/get?pick=true",
          isMulti: true,
          setOutput: v => v
        },
        disabled: true
      },
      {
        col: 6,
        name: "userEdit",
        value: "",
        type: "select",
        label: `${this.M}userGroupAccessModify`,
        opts: {
          style: "float-label",
          path: "admGroup/get?pick=true",
          isMulti: true,
          setOutput: v => v
        },
        disabled: true
      },
      {
        col: 4,
        name: "hidden",
        value: null,
        type: "switch",
        label: "main.hidden"
      }
    ]

    this.setState({defaultFields: fields})
  }

  createFormTwo () {
    const isAuthorized = +this.props.userAdmin.role >= 95
    if (!isAuthorized) return
    const fields = [
      {
        name: "id",
        value: "",
        type: "hidden",
      },
      {
        col: 4,
        name: "name",
        value: "",
        type: "text",
        label: "main.name",
        rules: "required",
        opts: {
          style: "float-label"
        }
      },
      {
        col: 4,
        name: "email",
        value: "",
        type: "text",
        label: "main.email",
        opts: {
          style: "float-label"
        }
      },
      {
        col: 4,
        name: "domain",
        value: "",
        type: "text",
        label: "main.websiteUrl",
        opts: {
          style: "float-label"
        }
      },
      {
        col: 4,
        name: "tel",
        value: "",
        type: "tel",
        label: "main.phone",
        opts: {
          style: "float-label"
        }
      },
      {
        col: 4,
        name: "cel",
        value: "",
        type: "tel",
        label: "main.cellPhone",
        opts: {
          style: "float-label"
        }
      },
      {
        col: 4,
        name: "color",
        value: "",
        type: "select",
        label: "main.themeColor",
        opts: {
          style: "float-label",
          items: themeColors
        }
      },
      {
        col: 4,
        name: "img",
        value: "",
        type: "dropzone",
        label: "main.logo",
        opts: {
          path: ()=> "company/file",
          accept: '.jpeg,.jpg,.png',
          output: true
        }
      },
      {
        col: 12,
        name: "btn1",
        value: "",
        type: "button",
        label: "main.save",
        onClick: () => {
          this.updateCompanyProfile()
        }
      },
    ]

    this.setState({companyProfileFields: fields}, () => {
      this.fetchCompanyProfile();
    });
  }

  setFormvalues (data) {
    let fields = cloneDeep(this.state.companyProfileFields);
    fields.forEach((f) => {
      if (f.type !== 'label' && f.type !== 'button') {
        f.value = data[f.name] || '';
      }
      if (f.type === 'dropzone') f.opts.url = data[f.name]
    });
    this.setState({companyProfileFields: fields, ready: true});
  }

  fetchCompanyProfile () {
    this.props.setLoader(true);
    _axios
      .get('company/profile')
      .then(r => {
        this.props.setLoader(false);
        if (r.status >= 0) {
          r.data.img = r.data.img ? `${r.data.img}?t=${Date.now()}` : ""
          this.setFormvalues(r.data)
        }
        NotificationManager[r.status >= 0 ? 'success' : 'error'](r.msg, r.status >= 0 ? '' : 'Opps', 5000, null, null, 'outline');
      })
      .catch(() => {
        this.props.setLoader(false);
      });
  }

  updateCompanyProfile () {
    this.validateFormCompany().then(() => {
      let item = cloneDeep(this.state.companyProfileForm)
      let body = {...item, ...{
        img: Array.isArray(item.img) ? (item.img.length > 0 ? item.img[0].name : null) : item.img,
      }}
      // console.log(body)
      this.props.setLoader(true)
      _axios
        .post(`company/profile`, body)
        .then(r => {
          this.props.setLoader(false)
          if (r.status >= 0) {
            this.uploadFiles(r.data.id).then((response) => {
              this.defaultValuesUploadFiles()
              this.setState({ready: false}, () => {
                r.data.img = `https://jdblob.blob.core.windows.net/${window.tenant.isPro?"img":"img-dev"}/comp/${window.tenant.id}.jpg?t=${Date.now()}`
                this.setFormvalues(r.data);
                this.setState({ready: true});
                localStorage.setItem("__theme_color", r.data.color)
                const toogle = () => {
                  let d = this.state.dialog
                  d.isOpen = !d.isOpen
                  this.setState({dialog: d})
                }
                this.setState({dialog: {
                  isOpen: true,
                  toggle: toogle,
                  msg: "Would you like to reload the page to apply the changes?",
                  confirm: (e) => {
                    if (e) window.location.reload();
                    else toogle();
                  }
                }})
              });
              
              if (r.msg) NotificationManager.success(r.msg, '', 4000, null, null, 'outline')
            })
          } else NotificationManager.error(r.msg, 'Opps', 4000, null, null, 'outline')
        })
        .catch((e) => { this.props.setLoader(false) })
    })
    .catch(e => { /* console.log(e) */ })
  }

  fetchModules (isAdmin = null) {
    this.setState({isAdmin: isAdmin, data: [], message: null}, () => {
      if (isAdmin === null) {
        let userMenu = cloneDeep(this.props.menuItems)
        userMenu = userMenu.filter(m => !m.hidden && m.id !== 'home').map(m => {
          m.subs = m.subs.filter(sm => !sm.hidden)
          return m
        })
        this.setState({data: userMenu})
        return
      }
      this.props.setLoader(true)
      _axios
        .get(`admModule/get?admin=${isAdmin}&classic=false`)
        .then(r => {
          this.props.setLoader(false)
          if (r.status >= 0) {
            r.data.Results.map(e => { e.label = e.name; e.id = e.ID; e.to = `/app/${e.ID}`; return e })
            // r.data.Results.map(e => { e.label = e.name; e.id = e.ID; e.to = `/app/${e.ID}`; e.setupMsg = "Mensaje de prueba"; return e })
            this.setState({data: r.data.Results, message: r.data.Results.length === 0 ? 'main.noRecords' : null})
          }
          NotificationManager[r.status >= 0 ? 'success' : 'error'](r.msg, r.status >= 0 ? '' : 'Opps', 5000, null, null, 'outline')
        })
        .catch(() => {
          this.props.setLoader(false)
        })
    })
  }

  fetchModule (id) {
    this.setState({idItemSelected: id})
    this.props.setLoader(true)
    _axios
      .get(`admModule/get/${id}`)
      .then(r => {
        this.props.setLoader(false)
        if (r.status >= 0) {
          let fields = cloneDeep(this.state.defaultFields)
          fields.forEach((f) => {
            if (f.type !== 'label') f.value = r.data[f.name]
            if (f.name === 'parentId') f.value = {value: r.data['parentId'], label: r.data['parentName']}
          })
          this.setState({fields: fields}, () => { this.toggle() })
        }
        NotificationManager[r.status >= 0 ? 'success' : 'error'](r.msg, r.status >= 0 ? '' : 'Opps', 5000, null, null, 'outline')
      })
      .catch(() => {
        this.props.setLoader(false)
      })
  }

  updateModule () {
    this.validateForm().then(() => {
      let body = cloneDeep(this.state.form)
      if (body.userEdit) {
        body.userEdit = body.userEdit.map(e => {
          e = { ID: e.value, name: e.label, selected: true }
          return e
        })
      }
      if (body.userRead) {
        body.userRead = body.userRead.map(e => {
          e = { ID: e.value, name: e.label, selected: true }
          return e
        })
      }

      this.props.setLoader(true)
      _axios
        .post(`admModule/edit/${this.state.idItemSelected}`, body)
        .then(r => {
          this.props.setLoader(false)
          if (r.status >= 0) {
            this.toggle()
            this.fetchModules(this.state.isAdmin)
          }
          NotificationManager[r.status >= 0 ? 'success' : 'error'](r.msg, r.status >= 0 ? '' : 'Opps', 5000, null, null, 'outline')
        })
        .catch((e) => { this.props.setLoader(false) })
    })
    .catch(e => { /* console.log(e) */ })
  }

  uploadFiles (id) {
    return new Promise((resolve, reject) => {
      try {
          this.props.setLoader(true)

          let setUploadActive = () => {
            if (this.state.uploadActive < 1) {
              this.setState({ uploadActive: this.state.uploadActive + 1 }, () => {
                if (this.state.uploadActive >= 1) {
                  this.props.setLoader(false)
                  return resolve('ok')
                }
                this.setState({
                  uploadFiles: {id: id, name: 'img', success: setUploadActive },
                })
              })
            }
          }

          this.setState({uploadActive: 0}, () => {
            this.setState({
              uploadFiles: {id: id, name: 'img', success: setUploadActive },
            })
          })

      } catch (error) {
        reject(error)
      }
    })
  }

  defaultValuesUploadFiles () {
    this.setState({
      uploadActive: -1,
      uploadFiles: null,
    })
  }

  listenStatesFormOne = (form) => {
    this.setState({form: form})
  }

  listenStatesFormTwo = (form) => {
    this.setState({companyProfileForm: form});
  }

  toggle = () => {
    this.setState(prevState => ({
      modal: !prevState.modal
    }))
  }

  goTo = (m) => {
    if (m.hidden) return
    else if (this.state.isAdmin === false) {
      this.fetchModule(m.id)
      return
    }
    this.props.setParams({setupMsg: m.setupMsg})
    this.props.history.push(m.to)
  }

  createCard = (m, i) => {
    const card = <Colxx xl="3" lg="4" md="6" xs="12" key={`sm-${i}`} className="mb-3">
      <Card className={`${m.hidden ? 'opacity-50 pointer-na' : 'pointer'} h-100`} onClick={() => { this.goTo(m) }}>
        <CardBody>
          <div className="adm-module-toolbar">
            {m.setupMsg && <Button color="primary" size="xs" onClick={(e) => { e.stopPropagation(); this.goTo(m) }}>
              {this.L["main.completeSetup"]}
            </Button>}
            {false && <Button color="primary" className="btn-small-circular ml-1" outline onClick={(e) => { e.stopPropagation(); }}>
              <i className="simple-icon-bell"></i>
            </Button>}
            {m.ai && <Button color="primary" className="btn-small-circular ml-1" outline onClick={(e) => { e.stopPropagation(); }}>
              {this.L["main.ai"]}
            </Button>}
            {this.state.isAdmin !== null && <Button color="primary" className="btn-small-circular ml-1 border-0" outline onClick={(e) => { e.stopPropagation(); this.fetchModule(m.id) }}>
              <i className="simple-icon-options-vertical"></i>
            </Button>}
          </div>
          <div><i className={`${m.icon} h1 color-theme-1`} style={{marginLeft: "-8px"}}></i></div>
          <h5>{m.label}</h5>
          <p className="text-small text-muted mb-0">{m.desc}</p>
        </CardBody>
      </Card>
    </Colxx>
    return card
  }

  render () {
    const { locale } = this.props
    const L = AppLocale[locale].messages
    const { data, isAdmin, idItemSelected, ready, companyProfileFields, uploadFiles, message } = this.state
    const { M } = this
    return (
      <Fragment>
        <Row>
          <Colxx xxs="12">
            <div className="d-flex justify-content-end mb-3">
              <CustomDropdown
                label={"main.admin"}
                direction="left"
                showItemSelected={true}
                items={[
                  {name: `${M}myAccess`, onClick: () => { this.fetchModules(null) }},
                  {name: `${M}manageAdminModules`, onClick: () => { this.fetchModules(true); this.createFormTwo() }},
                  // {name: `${M}manageAppAIModules`, onClick: () => { this.fetchModules(false) }}
                ]}
              />
            </div>
          </Colxx>

          {isAdmin && ready && <Colxx xxs="12">
            <Card className="mb-4">
              <CardBody>
                <h4 className="mb-4">Company profile</h4>
                <FormCustom
                  id={"form-data-tenant"}
                  fields={companyProfileFields}
                  listenStates={this.listenStatesFormTwo}
                  didUpdateStates={true}
                  validate={ctx => this.validateFormCompany = ctx}
                  uploadFiles={uploadFiles}
                />
              </CardBody>
            </Card>
          </Colxx>}

          <Colxx sm="12">
            {message && <div className="text-muted">{L[message]}</div>}
            <Row>
              {data.map((m, i) => {
                const a = (m, i) => {
                  return <Colxx sm="12" key={`m-${i}`}>
                    <Row>
                      <Colxx sm="12"><h3 className="mb-3">{m.name}</h3></Colxx>
                      {m.subs?.length === 0 && this.createCard(m, i)}
                      {m.subs?.map((sm, i) => this.createCard(sm, i))}
                    </Row>
                  </Colxx>
                }
                const b = this.createCard(m, i)
                return (isAdmin == null ? a(m, i) : b)
              })}
            </Row>
          </Colxx>
        </Row>

        <CustomModal 
          isOpen={this.state.modal}
          toggle={this.toggle}
          backdrop={"static"}
          wrapClassName={"modal-right"}
          size="lg"
        >
          <ModalHeader toggle={this.toggle}>
            <small>{ `${idItemSelected ? L["main.edit"] : L["main.create"]}: ${data.find(d => d.id === idItemSelected)?.label}`}</small>
          </ModalHeader>
          <ModalBody>
            {this.state.fields?.length > 0 &&
              <FormCustom
                id={"form-crud"}
                edit={idItemSelected ? true : false}
                fields={idItemSelected ? this.state.fields : this.state.defaultFields}
                listenStates={this.listenStatesFormOne}
                validate={fn => this.validateForm = fn}
                didUpdateStates={true}
              />
            }
          </ModalBody>
          <ModalFooter>
            <Button
              color="primary"
              size="sm"
              onClick={() => { idItemSelected ? this.updateModule() : this.create() }}>
              {idItemSelected ? L["main.save"] : L["main.create"]}
            </Button>
            <Button outline color="secondary" size="sm" onClick={() => { this.toggle() }}>{L["main.cancel"]}</Button>
          </ModalFooter>
        </CustomModal>

        <Dialog {...this.state.dialog}></Dialog>
      </Fragment>
    )
  }
}

const mapStateToProps = ({ settings, menu, utils, authUser }) => {
  const { menuItems, menuHiddenBreakpoint } = menu
  const { locale } = settings
  const { params } = utils
  const { userAdmin } = authUser
  return { locale, menuHiddenBreakpoint, menuItems, userAdmin, params }
};

export default connect(mapStateToProps, { setLoader, setParams, setContainerClassnames })(Start);

